import React from 'react';
import './HomieStores.css';
import storeImage from '../../Homepage_Store_West Hartford.jpg';
import OutlinedButton from './OutlinedButton.tsx';

const HomieStores: React.FC = () => {
  return (
    <section className="homie-stores">
      <div className="homie-stores__content">
        <div className="homie-stores__text">
          <h2 className="homie-stores__title">OUR STORES</h2>
          <div className="homie-stores__divider" />
          <p className="homie-stores__description">
            We make shopping for cannabis worry-free with expert recommendations, quality products, and daily discounts.
          </p>
          <div className="homie-stores__button">
            <OutlinedButton to="/store">FIND A STORE</OutlinedButton>
          </div>
        </div>
        <div className="homie-stores__image-container">
          <img
            src={storeImage}
            alt="Sweetspot Store - West Hartford"
            className="homie-stores__image"
          />
        </div>
      </div>
    </section>
  );
};

export default HomieStores;
